import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LanguageService } from './language.service';
import { LocalStorageProvider } from 'app/shared';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class LanguageModule {

  static forRoot(): ModuleWithProviders {
    return {
        ngModule: LanguageModule,
        providers: [
          LanguageService,
          LocalStorageProvider
        ]
      };
  }

  static forChild(): ModuleWithProviders {
    return {
        ngModule: LanguageModule
      };
  }
}



// WEBPACK FOOTER //
// /dist/src/app/language/language.module.ts